import { VideoSection } from "./VideoSection"

export const InfoSection = ({ children, img, video }) => {
    return (
        <div className='info-section'>
            <section>
                {children}
            </section>
            <section >
                {img && <img src={img} />}
                {video && <VideoSection url={video} />}
            </section>
        </div>
    )
}